export class UserLoggedOutMessage
{
    public authFailed: boolean;

    constructor(authFailed: boolean = false) {
        this.authFailed = authFailed;
    }
}